import http from '../../../Utils/http';

const GetEntities = {
  name: 'signJetSyncEntities',
  state: {
    loading: false,
    error: '',
    data: [],
    totalCount: 0,
  },
  reducers: {
    EntitiesRequested(state) {
      return { ...state, loading: true, error: '' };
    },
    EntitiesReceived(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        data: Array.isArray(payload?.data?.rows) ? payload.data.rows : [],
        totalCount: payload?.data?.count || 0,
      };
    },
    EntitiesRequestFailed(state, payload) {
      return { ...state, loading: false, error: payload, data: [], totalCount: 0 };
    },
  },
  effects: (dispatch) => ({
    async requestForEntities({ run_id, org_id, entity_type, link_status, axonet_ready, search, page, rpp, sorted_by, sort }) {
      try {
        this.EntitiesRequested();
        const params = new URLSearchParams();
        if (run_id) params.append('run_id', run_id);
        if (org_id) params.append('org_id', org_id);
        if (entity_type) params.append('entity_type', entity_type);
        if (link_status) params.append('link_status', link_status);
        if (axonet_ready) params.append('axonet_ready', axonet_ready);
        if (search) params.append('search', search);
        if (sorted_by) params.append('sorted_by', sorted_by);
        if (sort) params.append('sort', sort);
        params.append('page', String(page));
        params.append('rpp', String(rpp));

        const response = await http.get(`savvy/signjet-sync/entities?${params.toString()}`);
        this.EntitiesReceived(response.data);
      } catch (err) {
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.EntitiesRequestFailed(message);
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', data: 'Failed to load sync entities', open: true },
        });
      }
    },
  }),
};

export default GetEntities;
